{
  "familyId": "GET-WORTEL",
  "questions": [
    {
      "id": "GET-WORTEL-001",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Wat betekent $\\sqrt{9}$?",
      "context": null,
      "options": [
        "welk getal keer zichzelf geeft 9?",
        "9 × 2",
        "9 ÷ 2",
        "9 + 9"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_meaning",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat is een wortel?",
            "content": "Het wortelteken √ vraagt: welk getal × zichzelf = het getal onder het teken? Voorbeeld: √9 = 3, want 3 × 3 = 9."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 'welk getal keer zichzelf geeft 9?'. Het wortelteken √ vraagt: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9. Dus √9 = 3.",
        "distractorExplanations": {
          "0": "Goed! √9 betekent: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9.",
          "1": "9 × 2 = 18 is fout. Het wortelteken is geen vermenigvuldiging met 2. √ vraagt: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9.",
          "2": "9 ÷ 2 = 4,5 is fout. Het wortelteken is geen deling door 2. √ vraagt: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9.",
          "3": "9 + 9 = 18 is fout. Het wortelteken is geen optelling. √ vraagt: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9."
        }
      }
    },
    {
      "id": "GET-WORTEL-002",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{16}$ =",
      "context": null,
      "options": ["4", "8", "2", "256"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixteen",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 16? Probeer: 4 × 4 = 16. ✓ Dus √16 = 4."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 4. Vraag: welk getal × zichzelf = 16? Probeer: 4 × 4 = 16. ✓ Dus √16 = 4.",
        "distractorExplanations": {
          "0": "Goed! √16 = 4, want 4 × 4 = 16.",
          "1": "8 is fout. Je hebt misschien 16 ÷ 2 = 8 berekend, maar dat is geen wortel. Wortel: welk getal × zichzelf = 16? Dat is 4, want 4 × 4 = 16 (niet 8 × 8 = 64).",
          "2": "2 is fout. 2 × 2 = 4, niet 16. Probeer 4: 4 × 4 = 16. ✓ Dus √16 = 4.",
          "3": "256 is fout. Je hebt misschien 16 × 16 = 256 berekend (kwadraat in plaats van wortel). Wortel is het omgekeerde: welk getal × zichzelf = 16? Dat is 4."
        }
      }
    },
    {
      "id": "GET-WORTEL-003",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{25}$ =",
      "context": null,
      "options": ["5", "12,5", "50", "625"],
      "correctAnswer": 0,
      "conceptId": "square_root_twentyfive",
      "variantIndex": 3,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 25? Probeer: 5 × 5 = 25. ✓ Dus √25 = 5."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 5. Vraag: welk getal × zichzelf = 25? Probeer: 5 × 5 = 25. ✓ Dus √25 = 5.",
        "distractorExplanations": {
          "0": "Goed! √25 = 5, want 5 × 5 = 25.",
          "1": "12,5 is fout. Je hebt misschien 25 ÷ 2 = 12,5 berekend, maar dat is geen wortel. Wortel: welk getal × zichzelf = 25? Dat is 5, want 5 × 5 = 25.",
          "2": "50 is fout. Je hebt misschien 25 × 2 = 50 berekend. Wortel is niet vermenigvuldigen met 2. Wortel: welk getal × zichzelf = 25? Dat is 5.",
          "3": "625 is fout. Je hebt misschien 25 × 25 = 625 berekend (kwadraat in plaats van wortel). Wortel is het omgekeerde: welk getal × zichzelf = 25? Dat is 5."
        }
      }
    },
    {
      "id": "GET-WORTEL-004",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{64}$ =",
      "context": null,
      "options": ["8", "32", "4", "4096"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixtyfour",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 64? Probeer: 8 × 8 = 64. ✓ Dus √64 = 8."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 8. Vraag: welk getal × zichzelf = 64? Probeer: 8 × 8 = 64. ✓ Dus √64 = 8.",
        "distractorExplanations": {
          "0": "Goed! √64 = 8, want 8 × 8 = 64.",
          "1": "32 is fout. Je hebt misschien 64 ÷ 2 = 32 berekend, maar dat is geen wortel. Wortel: welk getal × zichzelf = 64? Dat is 8, want 8 × 8 = 64 (niet 32 × 32 = 1024).",
          "2": "4 is fout. 4 × 4 = 16, niet 64. Probeer 8: 8 × 8 = 64. ✓ Dus √64 = 8.",
          "3": "4096 is fout. Je hebt misschien 64 × 64 = 4096 berekend (kwadraat in plaats van wortel). Wortel is het omgekeerde: welk getal × zichzelf = 64? Dat is 8."
        }
      }
    },
    {
      "id": "GET-WORTEL-005",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{100}$ =",
      "context": null,
      "options": ["10", "50", "20", "10000"],
      "correctAnswer": 0,
      "conceptId": "square_root_hundred",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.82,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 100? Probeer: 10 × 10 = 100. ✓ Dus √100 = 10."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 10. Vraag: welk getal × zichzelf = 100? Probeer: 10 × 10 = 100. ✓ Dus √100 = 10.",
        "distractorExplanations": {
          "0": "Goed! √100 = 10, want 10 × 10 = 100.",
          "1": "50 is fout. Je hebt misschien 100 ÷ 2 = 50 berekend, maar dat is geen wortel. Wortel: welk getal × zichzelf = 100? Dat is 10, want 10 × 10 = 100.",
          "2": "20 is fout. 20 × 20 = 400, niet 100. Probeer 10: 10 × 10 = 100. ✓ Dus √100 = 10.",
          "3": "10000 is fout. Je hebt misschien 100 × 100 = 10000 berekend (kwadraat in plaats van wortel). Wortel is het omgekeerde: welk getal × zichzelf = 100? Dat is 10."
        }
      }
    },
    {
      "id": "GET-WORTEL-006",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Welke is groter: $\\sqrt{36}$ of $\\sqrt{49}$?",
      "context": null,
      "options": [
        "$\\sqrt{49}$",
        "$\\sqrt{36}$",
        "ze zijn even groot",
        "dat kun je niet zeggen"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_compare",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortels vergelijken",
            "content": "Bereken beide wortels: √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 > √36."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is √49. Bereken beide wortels: √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 > √36.",
        "distractorExplanations": {
          "0": "Goed! √49 = 7 en √36 = 6, dus √49 > √36.",
          "1": "√36 is fout. √36 = 6 en √49 = 7. Omdat 7 > 6, is √49 groter dan √36.",
          "2": "Ze zijn niet even groot. √36 = 6 en √49 = 7. Dat zijn verschillende getallen: 7 ≠ 6.",
          "3": "Je kunt het wél zeggen. Bereken beide: √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 is groter."
        }
      }
    }
  ]
}
